import {Race} from "../race";
import {EventItem} from "../event-item";
import {PaymentStatus} from "../wspay/wspay-confirmation";
import {Competitor} from "../competitor";
import {RegistrationStatus} from "./registration-status";
import {PaymentType} from "./payment-type";
import {PaymentOrder} from "./payment-order";

export class RaceRegistration {
  id?: number;
  raceId?: number;
  userId?: number;
  receiptEmail?: string;
  registrationStatus?: RegistrationStatus;
  paymentTypes?: PaymentType[];
  totalAmount?: number;
  totalAmountWithDiscount?: number;
  created?: Date;
  paymentTimestamp?: Date;
  endDateForPayment?: Date;
  currencyCode?: string;
  wsPayFormUrl?: string;
  wsPayCartId?: string;
  wsPayApprovalCode?: string;
  wsPayTransactionId?: string;
  paymentStatus?: PaymentStatus;
  competitors?: Competitor[];
  teamRegistration?: boolean;
  order?: PaymentOrder;
  race?: Race;
  events?: EventItem;

  static getTypeOfRegistration(raceRegistration?: RaceRegistration): TypeOfRegistration {
    var typeOfRegistration: TypeOfRegistration;
    if (raceRegistration?.teamRegistration) {
      typeOfRegistration = TypeOfRegistration.TEAM;
    } else if ((raceRegistration?.competitors?.length ?? 0) > 0) {
      typeOfRegistration = TypeOfRegistration.GROUP;
    } else {
      typeOfRegistration = TypeOfRegistration.SINGLE;
    }
    return typeOfRegistration;
  }
}

export enum TypeOfRegistration {
  SINGLE = 0, GROUP = 1, TEAM = 2
}
